export const styles = {
  divIcon: {
    cursor: 'pointer',
    marginBottom: '5px',
  },
};
